import { isRateLimitError } from '../types/guards';
import type { Message } from '../types/messages';
import { checkRateLimit } from '../utils';

import { widgetApi } from '../../config';

interface HistoryApiParams {
  token: string | null;
  size?: number;
  fromId?: number;
  sort?: 'DESC' | 'ASC';
}

interface HistoryApiResult {
  messages: Message[];
  hasMore: boolean;
}

export const getHistoryApi = async ({ token, size, fromId, sort }: HistoryApiParams) => {
  const searchParams = new URLSearchParams();

  if (size) {
    searchParams.set('size', size.toString());
  }

  if (fromId) {
    searchParams.set('fromId', fromId.toString());
  }

  if (sort) {
    searchParams.set('sort', sort.toString());
  }

  try {
    const result = await fetch(`${widgetApi}/history?${searchParams.toString()}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    await checkRateLimit(result);

    if (!result.ok) {
      return null;
    }

    return (await result.json()) as HistoryApiResult;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    // Пробрасываем rate limit ошибку дальше
    if (isRateLimitError(error)) {
      if (typeof error === 'string') {
        throw new Error(error);
      }
    }
    return null;
  }
};
